import React, {Component} from 'react';
import {Button} from "primereact/button";
import {AmountOperationService} from "../../../service/limitControl/AmountOperationService";
import AmountOperation from "./AmountOperationView";
import {withoutComma} from "../../../utils/calculate/Amount";
import {Growl} from "primereact/growl";
import {CatalogService} from "../../../service/catalog/CatalogService";
import {MAX_CREDIT_AMOUNT, PTM_ROL} from "../../../utils/constants/Constants"

export default class AmountOperationContainer extends Component {

    constructor(props) {
        super(props);

        this.amountOperationService = new AmountOperationService();
        this.catalogService = new CatalogService();

        this.loading = this.loading.bind(this);
        this.saveFilters = this.saveFilters.bind(this);
        this.getAmountOperation = this.getAmountOperation.bind(this);
        this.onHideDialog = this.onHideDialog.bind(this);
        this.showEditDialog = this.showEditDialog.bind(this);
        this.amountOrderActionTemplate = this.amountOrderActionTemplate.bind(this);
        this.saveData = this.saveData.bind(this);
        this.saveRadioButtonOption = this.saveRadioButtonOption.bind(this);
        this.setAmountOperation = this.setAmountOperation.bind(this);
        this.getErrors = this.getErrors.bind(this);
        this.clearFilters = this.clearFilters.bind(this);
        this.getInstitutions = this.getInstitutions.bind(this);
        this.onSelectionChangeTable = this.onSelectionChangeTable.bind(this);

        this.state = {
            isLoading: true,
            catInstitutionBorrowerFilter: '',
            amountOperationList: [],
            amountOperationSelected: '',
            displayDialog: false,
            institutionList: this.getInstitutions(),
        };

        this.getAmountOperation();
    }


    loading(isLoading) {
        if (this.state !== undefined) {
            this.setState({
                isLoading: isLoading
            });
        }
    }

    saveFilters(event) {
        const {name, value} = event.target;
        this.setState({[name]: value,})
    }

    onHideDialog() {
        this.setState({displayDialog: false});
        this.getAmountOperation();
    }

    showEditDialog(dataSelected) {
        dataSelected['lineaEstablecida'] = dataSelected['lineaEstablecida'] === 0 ?
            '' : dataSelected['lineaEstablecida'];
        this.setState({
            displayDialog: true,
            amountOperationSelected: dataSelected,
        });
    }

    getInstitutions() {
        this.catalogService.getCatalogInstitutionByRol(PTM_ROL)
            .then(resp => {
                this.setState({
                    institutionList: resp,
                });
            });
    }

    saveData(event) {
        const {name, value} = event.target;
        let amountOperationSelected = this.state.amountOperationSelected;
        amountOperationSelected[name] = value;
        this.setState({amountOperationSelected: amountOperationSelected,})
    }

    saveRadioButtonOption(event) {
        if(event.value === 'no' &&
            Number(withoutComma(this.state.amountOperationSelected['montoUtilizado'])) !== 0){
            this.growl.show({
                severity: 'error', summary: 'Error.',
                detail: 'No se puede realizar esta operación si se tienen prestamos vigentes.'
            });

        }else{
            let amountOperationSelected = this.state.amountOperationSelected;
            amountOperationSelected['opera'] = event.value === 'yes' ? "1" : "0";
            amountOperationSelected['lineaEstablecida'] = event.value === 'no' ?
                '' : amountOperationSelected['lineaEstablecida'];

            this.setState({amountOperationSelected: amountOperationSelected,})
        }
    }

    getAmountOperation() {
        this.loading(true);
        if (localStorage.getItem('institution') !== 'Interno') {
            this.amountOperationService.getAmountOperationInstitution()
                .then(response => {
                    this.setState({
                        amountOperationList: response,
                    });
                    this.loading(false);
                });
        } else {
            this.amountOperationService.getAmountOperationAdministrator(
                this.state.catInstitutionBorrowerFilter.idInstitucion)
                .then(response => {
                    this.setState({
                        amountOperationList: response,
                    });
                    this.loading(false);
                });
        }
    }

    clearFilters() {
        this.setState({
            catInstitutionBorrowerFilter: {}
        });
    }

    amountOrderActionTemplate(rowData, column) {
        let dataSelected = JSON.parse(JSON.stringify(rowData));
        return (
            <Button type="button"
                    label="Editar"
                    onClick={() => this.showEditDialog(dataSelected)}/>
        );
    }
    onSelectionChangeTable(event){
        this.setState({
            amountOperationSelectedTab: event.value,
        });
    }

    getErrors() {
        let amountOperationAux = this.state.amountOperationSelected;
        let msg = "";
        if (amountOperationAux['lineaEstablecida'] === '' ||
            amountOperationAux['lineaEstablecida'] === null) {
            msg = "No puede dejar la línea de crédito en blanco"
        } else if (amountOperationAux['opera'] === '1' &&
            Number(withoutComma(amountOperationAux['lineaEstablecida'])) <= 0) {
            msg = "Debe colocar una línea de crédito mayor a cero para operar con la institución"
        } else if (amountOperationAux['opera'] === '0' &&
            Number(withoutComma(amountOperationAux['lineaEstablecida'])) > 0) {
            msg = "Debe operar con la institución para tener una línea de crédito."
        }else if(Number(withoutComma(amountOperationAux['lineaEstablecida'])) <
            Number(withoutComma(amountOperationAux['montoUtilizado']))){
            msg = 'El monto de la línea de crédito disponible, debe ser mayor o igual al monto utilizado.'
        }else if(Number(withoutComma(amountOperationAux['lineaEstablecida']) > MAX_CREDIT_AMOUNT)){
            msg = 'Ha excedido el monto máximo permitido para la línea de crédito.'
        }
        return msg;
    }

    setAmountOperation() {
        let errorMsg = this.getErrors();

        if (errorMsg !== '') {
            this.growl.show({
                severity: 'error', summary: 'Error.',
                detail: errorMsg
            });
        } else {
            this.loading(true);
            this.amountOperationService.setAmountOperation(
                this.state.amountOperationSelected.idInstitucionPTT,
                this.state.amountOperationSelected.opera,
                withoutComma(this.state.amountOperationSelected.lineaEstablecida)
            ).then(resp => {
                if (resp.message === "") {
                    this.growl.show({
                        severity: 'success', summary: 'Éxito.',
                        detail: 'Los datos se han actualizado con éxito.'
                    });
                } else if (resp.error !== "") {
                    this.growl.show({severity: 'error', summary: 'Error.', detail: resp.error});
                }
                this.loading(false);
                this.onHideDialog();
                this.setState({
                    amountOperationSelected: '',
                });
            });
        }
    }

    render() {
        let dialogHeader =
            <div className="p-grid p-fluid">
                <div className="p-col-12 p-md-8 p-lg-8" style={{padding: '.1em'}}>
                    <h2 className={"secondary-text"}>Editar Monto de Operación</h2>
                </div>
                <div className="p-col-12 p-md-2 p-lg-2" style={{padding: '.2em'}}>
                    <Button label="Regresar" onClick={this.onHideDialog}
                            className="p-button-secondary"/>
                </div>
                <div className="p-col-12 p-md-2 p-lg-2" style={{padding: '.2em'}}>
                    <Button label="Guardar" onClick={this.setAmountOperation}/>
                </div>
            </div>;
        let messagesGrowl = <Growl ref={(el) => this.growl = el}/>;

        return (
            <AmountOperation
                isLoading={this.state.isLoading}
                loading={this.loading}
                dialogHeader={dialogHeader}
                messagesGrowl={messagesGrowl}
                displayDialog={this.state.displayDialog}
                onHideDialog={this.onHideDialog}
                catInstitutionBorrowerFilter={this.state.catInstitutionBorrowerFilter}
                saveFilters={this.saveFilters}
                saveData={this.saveData}
                saveRadioButtonOption={this.saveRadioButtonOption}
                setAmountOperation={this.setAmountOperation}
                getAmountOperation={this.getAmountOperation}
                amountOperationList={this.state.amountOperationList}
                amountOperationSelected={this.state.amountOperationSelected}
                amountOrderActionTemplate={this.amountOrderActionTemplate}
                clearFilters={this.clearFilters}
                institutionList={this.state.institutionList}
                amountOperationSelectedTab={this.state.amountOperationSelectedTab}
                onSelectionChangeTable={this.onSelectionChangeTable}
            />
        );
    }
}
